export default {
  DAYS: 'days',
  MONTHS: 'months',
  YEARS: 'years',
}
